// extracted by mini-css-extract-plugin
export var closeButton = "_1d-1";
export var container = "_1d-0";
export var fullModalImage = "_1d-2";